import { ConfigurationType } from "@/utilities/forms/ConfigurationFormProcessor";
import { IUpdateMapping } from ".";
import { ConfigurationUpdateEventMapping } from "./event";
import { ConfigurationUpdateFormMapping } from "./form";
import { ConfigurationUpdateVersionMapping } from "./version";
import { ConfigurationUpdateFieldMapping } from './field';
import { ConfigurationUpdateSectionMapping } from "./section";
import { ConfigurationUpdateValueMapping } from "./value";

export const UpdateMapping: Record<ConfigurationType, IUpdateMapping> = {
    [ConfigurationType.Event]: ConfigurationUpdateEventMapping,
    [ConfigurationType.Form]: ConfigurationUpdateFormMapping,
    [ConfigurationType.Version]: ConfigurationUpdateVersionMapping,
    [ConfigurationType.Section]: ConfigurationUpdateSectionMapping,
    [ConfigurationType.Field]: ConfigurationUpdateFieldMapping,
    [ConfigurationType.Value]: ConfigurationUpdateValueMapping
}